import echarts from 'echarts';
import 'echarts/map/js/china';
import 'echarts/map/js/china-contour';
import 'echarts/map/js/province/chongqing';
function drawChart(e: any) {
  // 基于准备好的dom，初始化echarts实例
  const myChart = echarts.init(
    document.getElementById('snake') as HTMLCanvasElement,
  );
  // 指定图表的配置项和数据
  interface Option {
    tooltip: {
      formatter: (params: any) => string;
      backgroundColor: string;
      textStyle: {
        color: string;
      };
    };
    visualMap: any;
    series: any;
  }
  const option: Option = {
    tooltip: {
      // 悬浮时显示
      formatter: (params: any) => {
        const info =
          '<div style="font-size:14px"> 省份：' +
          params.name +
          '</div><div style="font-size:14px"> 确诊：' +
          params.value +
          ' </div>';
        return info;
      },
      backgroundColor: 'rgba(51, 37, 21, 0.8)', // 提示标签背景颜色
      textStyle: { color: '#fff' }, // 提示标签字体颜色
    },
    visualMap: {
      show: true,
      x: 'left',
      // y: 'center',
      bottom: '0%', // 组件离容器下侧的距离,'20%'
      itemWidth: 6, // 图形的宽度，即长条的宽度。
      itemHeight: 16, // 图形的高度，即长条的高度。
      textGap: 5, // 两端文字主体之间的距离，单位为px
      textStyle: {
        // 文本样式
        fontSize: 10,
        color: '#000',
      },
      itemGap: 0, // 每两个图元之间的间隔距离，单位为px
      splitList: [
        { start: 999, label: '999人以上' },
        { start: 100, end: 999, label: '100-999人' },
        { start: 10, end: 99, label: '10-99人' },
        { start: 1, end: 9, label: '1-9人' },
        { end: 1, label: '0人' },
      ],
      color: ['#ed514e', '#ff8f66', '#ffb769', '#ffe6be', '#f6f6f6'],
    },
    series: [
      {
        name: '中国',
        type: 'map',
        zoom: 1.2, // 这里是关键，一定要放在 series中，地图缩放比例的配置
        mapType: 'china',
        itemStyle: {
          normal: {
            borderColor: '#be9b71',
          },
        },
        label: {
          // 地图中的文字
          normal: {
            // 正常显示
            show: true, // 显示省份标签
            textStyle: {
              fontSize: 8,
              color: '#000',
            },
          },
          emphasis: {
            // 悬浮时显示
            show: true, // 对应的鼠标悬浮效果
          },
        },
        data: e,
      },
    ],
  };
  myChart.setOption(option);
}

// 重庆地图
function ChongQChart(e: any) {
  // 基于准备好的dom，初始化echarts实例
  const myChart = echarts.init(
    document.getElementById('snake2') as HTMLCanvasElement,
  );
  // 指定图表的配置项和数据
  interface Option {
    tooltip: {
      formatter: (params: any) => string;
      backgroundColor: string;
      textStyle: {
        color: string;
      };
    };
    visualMap: any;
    series: any;
  }
  const option: Option = {
    tooltip: {
      // 悬浮时显示
      formatter: (params: any) => {
        const info =
          '<div style="font-size:14px"> 省份：' +
          params.name +
          '</div><div style="font-size:14px"> 确诊：' +
          params.value +
          ' </div>';
        return info;
      },
      backgroundColor: 'rgba(51, 37, 21, 0.8)', // 提示标签背景颜色
      textStyle: { color: '#fff' }, // 提示标签字体颜色
    },
    visualMap: {
      show: true,
      x: 'left',
      // y: 'center',
      bottom: '0%', // 组件离容器下侧的距离,'20%'
      itemWidth: 6, // 图形的宽度，即长条的宽度。
      itemHeight: 16, // 图形的高度，即长条的高度。
      textGap: 5, // 两端文字主体之间的距离，单位为px
      textStyle: {
        // 文本样式
        fontSize: 10,
        color: '#000',
      },
      itemGap: 0, // 每两个图元之间的间隔距离，单位为px
      splitList: [
        { start: 20 },
        { start: 10, end: 19 },
        { start: 5, end: 9 },
        { start: 1, end: 4 },
      ],
      color: ['#ed514e', '#ff8f66', '#ffb769', '#ffe6be'],
    },
    series: [
      {
        name: '重庆',
        type: 'map',
        zoom: 1.2, // 这里是关键，一定要放在 series中，地图缩放比例的配置
        mapType: '重庆',
        itemStyle: {
          normal: {
            borderColor: '#be9b71',
          },
        },
        label: {
          // 地图中的文字
          normal: {
            // 正常显示
            show: true, // 显示省份标签
            textStyle: {
              fontSize: 8,
              color: '#000',
            },
          },
          emphasis: {
            // 悬浮时显示
            show: true, // 对应的鼠标悬浮效果
          },
        },
        data: e,
        nameMap: {
          开州区: '开县',
        },
      },
    ],
  };
  myChart.setOption(option);
}

// 全国折线图1
function lineChart(e: any) {
  // 基于准备好的dom，初始化echarts实例
  const myChart = echarts.init(
    document.getElementById('snake3') as HTMLCanvasElement,
  );
  const option: any = {
    legend: {
      data: ['确诊', '疑似'],
      top: 20,
      right: 40,
    },
    tooltip: {
      trigger: 'axis',
      triggerOn: 'click',
    },
    xAxis: {
      type: 'category',
      data: e.country.time,
      axisTick: false,
      axisLabel: {
        margin: 10,
        textStyle: {
          color: '#333',
        },
        fontSize: 10,
        interval: 0,
        rotate: 40,
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        margin: 4,
        textStyle: {
          color: '#333',
        },
        fontSize: 10,
      },
      axisLine: false,
      axisTick: false,
    },
    series: [
      {
        data: e.country.data.ascertain,
        type: 'line',
        smooth: true,
        name: '确诊',
        color: '#e93333',
      },
      {
        data: e.country.data.suspected,
        type: 'line',
        smooth: true,
        name: '疑似',
        color: '#ff9f17',
      },
    ],
  };
  myChart.setOption(option);
  // 图2 start
  const myChart2 = echarts.init(
    document.getElementById('snake4') as HTMLCanvasElement,
  );
  const option2: any = {
    legend: {
      data: ['死亡', '治愈'],
      top: 20,
      right: 40,
    },
    tooltip: {
      trigger: 'axis',
      triggerOn: 'click',
    },
    xAxis: {
      type: 'category',
      data: e.country.time,
      axisTick: false,
      axisLabel: {
        margin: 10,
        textStyle: {
          color: '#333',
        },
        fontSize: 10,
        interval: 0,
        rotate: 40,
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        margin: 4,
        textStyle: {
          color: '#333',
        },
        fontSize: 10,
      },
      axisLine: false,
      axisTick: false,
    },
    series: [
      {
        data: e.country.data.death,
        type: 'line',
        smooth: true,
        name: '死亡',
        color: '#808080',
      },
      {
        data: e.country.data.cure,
        type: 'line',
        smooth: true,
        name: '治愈',
        color: '#78b17e',
      },
    ],
  };
  myChart2.setOption(option2);
  // 图2 end
  // 图3 start
  const myChart3 = echarts.init(
    document.getElementById('snake5') as HTMLCanvasElement,
  );
  const option3: any = {
    legend: {
      data: ['确诊', '治愈'],
      top: 20,
      right: 40,
    },
    tooltip: {
      trigger: 'axis',
      triggerOn: 'click',
    },
    xAxis: {
      type: 'category',
      data: e.country.time,
      axisTick: false,
      axisLabel: {
        margin: 10,
        textStyle: {
          color: '#333',
        },
        fontSize: 10,
        interval: 0,
        rotate: 40,
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        margin: 4,
        textStyle: {
          color: '#333',
        },
        fontSize: 10,
      },
      axisLine: false,
      axisTick: false,
    },
    series: [
      {
        data: e.chongqing.data.ascertain,
        type: 'line',
        smooth: true,
        name: '确诊',
        color: '#e93333',
      },
      {
        data: e.chongqing.data.cure,
        type: 'line',
        smooth: true,
        name: '治愈',
        color: '#78b17e',
      },
    ],
  };
  myChart3.setOption(option3);

  // 图4新增的全国每日新增图
  const myChart4 = echarts.init(
    document.getElementById('snake6') as HTMLCanvasElement,
  );
  const option4: any = {
    legend: {
      data: ['确诊新增', '疑似新增'],
      top: 20,
      right: 40,
    },
    tooltip: {
      trigger: 'axis',
      triggerOn: 'click',
    },
    xAxis: {
      type: 'category',
      data: e.country.time,
      axisTick: false,
      axisLabel: {
        margin: 10,
        textStyle: {
          color: '#333',
        },
        fontSize: 10,
        interval: 0,
        rotate: 40,
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        margin: 4,
        textStyle: {
          color: '#333',
        },
        fontSize: 10,
      },
      axisLine: false,
      axisTick: false,
    },
    series: [
      {
        data: e.country.addData.ascertain,
        type: 'line',
        smooth: true,
        name: '确诊新增',
        color: '#e93333',
      },
      {
        data: e.country.addData.suspected,
        type: 'line',
        smooth: true,
        name: '疑似新增',
        color: '#ff9f17',
      },
    ],
  };
  myChart4.setOption(option4);

  // 图5重庆每日确诊新增
  const myChart5 = echarts.init(
    document.getElementById('snake7') as HTMLCanvasElement,
  );
  const option5: any = {
    legend: {
      data: ['确诊新增'],
      top: 20,
      right: 40,
    },
    tooltip: {
      trigger: 'axis',
      triggerOn: 'click',
    },
    xAxis: {
      type: 'category',
      data: e.country.time,
      axisTick: false,
      axisLabel: {
        margin: 10,
        textStyle: {
          color: '#333',
        },
        fontSize: 10,
        interval: 0,
        rotate: 40,
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        margin: 4,
        textStyle: {
          color: '#333',
        },
        fontSize: 10,
      },
      axisLine: false,
      axisTick: false,
    },
    series: [
      {
        data: e.chongqing.addData.ascertain,
        type: 'line',
        smooth: true,
        name: '确诊新增',
        color: '#e93333',
      },
    ],
  };
  myChart5.setOption(option5);
}
export { drawChart, ChongQChart, lineChart };
